<template>
  <!-- 这里是首页 -->
  <div style="margin-bottom: 167px">
    <div class="zhuye">
      <el-carousel height="46.25vw" :interval="5000" arrow="always">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img :src="item.img" alt="" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 简介 -->
    <div class="c_introduction">
      <div class="c_pic">
        <img style="object-fit: contain" :src="tabData.show_img" alt="" />
      </div>
      <div
        class="c_box left"
        style="
          width: 1323px;
          position: absolute;
          top: 115px;
          left: 50% !important;
          transform: translate(-50%);
        "
      >
        <div class="c_word" style="width: 678px; margin: 0">
          <div class="c_title">
            <span class="c_tl" style="font-size: 28px; width: auto">{{
              tabData.reserve_4
            }}</span>
            <div
              class="bor"
              style="
                width: 30px;
                height: 3px;
                background-color: #234ce2;
                margin: 20px;
              "
            ></div>
          </div>
          <div
            class="c_text"
            v-html="tabData.content"
            style="color: #333; width: 678px; font-size: 18px"
          ></div>
          <div
            class="detail"
            style="color: #333; margin-bottom: 30px; cursor: pointer"
            @click="$router.push('/page/index/index')"
          >
            了解详情 >
          </div>
          <div class="shuzi" style="width: 480px">
            <div class="digit" v-if="tabData.reserve_1">
              <div>
                <div class="top">
                  <div class="big_digit" style="font-size: 42px">
                    {{ tabData.reserve_1 }}
                  </div>
                  <div class="right">
                    <div class="top1">+</div>
                    <div class="bottom1" style="padding-left: 2px">年</div>
                  </div>
                </div>
                <div class="bottom">
                  {{ tabData.reserve_desc_1 }}
                </div>
              </div>
            </div>
            <div class="digit" v-if="tabData.reserve_2">
              <div>
                <div class="top">
                  <div
                    class="big_digit"
                    style="margin-left: 6px; font-size: 42px"
                  >
                    {{ tabData.reserve_2 }}
                  </div>
                  <div class="right" style="margin-left: -15px">
                    <div class="top1"></div>
                    <div class="bottom1">所</div>
                  </div>
                </div>
                <div class="bottom">
                  {{ tabData.reserve_desc_2 }}
                </div>
              </div>
            </div>
            <div class="digit" v-if="tabData.reserve_3">
              <div>
                <div class="top">
                  <div class="big_digit" style="font-size: 42px">
                    {{ tabData.reserve_3 }}
                  </div>
                  <div class="right">
                    <div class="top1">+</div>
                    <div class="bottom1" style="margin-left: 3px">万</div>
                  </div>
                </div>
                <div class="bottom">
                  {{ tabData.reserve_desc_3 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 产品中心 -->
    <div class="c_introduction">
      <div class="c_pic">
        <img src="@/assets/img/bg/home2.png" alt="" />
      </div>
      <div class="c_box" style="margin: 0 auto; width: 1328px">
        <div class="c_word" style="margin: 0 auto; width: 1328px">
          <div class="c_title" style="padding: 0 10px; text-align: center">
            <div class="c_tl" style="width: auto; height: auto">
              {{ cpcenter?.t_name }}
            </div>
            <div
              class="e_tl"
              style="width: auto; height: auto; font-size: 24px"
            >
              {{ cpcenter?.t_name_deputy }}
            </div>
            <div
              class="bor"
              style="
                width: 30px;
                height: 3px;
                background-color: #234ce2;
                margin: 20px auto;
              "
            ></div>
          </div>
          <div class="cpcenter" style="margin-bottom: 100px">
            <div
              class="item"
              @click="clickCp(item)"
              v-for="item in cpcenter.child"
              :key="item.id"
            >
              <div class="bg">
                <img class="bgImg" :src="item.t_logo_deputy" alt="" />
              </div>
              <div class="logo">
                <img :src="item.t_logo_main" alt="" />
              </div>
              <div
                class="gang"
                style="width: 43px; height: 6px; background-color: #fff"
              ></div>
              <div class="text" style="width: 100%">
                <div class="cn_name">{{ item?.t_name }}</div>
                <div class="en_name">{{ item?.t_name_deputy }}</div>
              </div>
              <div class="look">查看 ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 品牌故事 -->
    <div class="c_introduction">
      <div class="c_pic">
        <img src="@/assets/img/bg/storeBanner.png" alt="" />
      </div>
      <div
        class="c_box"
        style="
          width: 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        "
      >
        <div class="c_word" style="text-align: center; width: 1344px">
          <div class="c_title" style="margin-bottom: 50px">
            <div class="c_tl" style="width: auto; height: auto">
              {{ story?.t_name }}
            </div>
            <div
              class="e_tl"
              style="width: auto; height: auto; font-size: 24px"
            >
              {{ story?.t_name_deputy }}
            </div>
            <div
              class="bor"
              style="
                width: 30px;
                height: 3px;
                background-color: #234ce2;
                margin: 20px auto;
              "
            ></div>
          </div>
          <div class="ppstory" style="margin-bottom: 100px">
            <div class="imgBoxs">
              <div
                class="imgbox"
                v-for="item in storys"
                :key="item.id"
                @click="clickBox(item)"
              >
                <div class="img">
                  <img
                    style="width: 319px; height: 205px"
                    :src="item.t_logo_main"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新闻中心 -->
    <div class="news">
      <div class="pageList">
        <div class="c_title" style="display: flex">
          <div
            class="bor"
            style="width: 3px; height: 42px; background-color: #234ce2"
          ></div>
          <span class="c_tl" style="width: auto">{{ news?.t_name }}</span>
          <span class="e_tl" style="height: auto; line-height: 60px">{{
            news?.t_name_deputy
          }}</span>
        </div>
        <div class="daohang">
          <div class="fenbu">
            <div
              v-for="item in news.child"
              :key="item.name"
              @click="handleNav(item)"
              :class="{ active: activeName == item.id }"
            >
              <span>{{ item.t_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="cont">
        <div class="left">
          <img :src="news.t_logo_main" alt="" />
        </div>
        <div class="right">
          <div class="news_list">
            <div
              class="new"
              @click="clickNew(item)"
              v-for="item in newsDataList"
              :key="item.id"
            >
              <div class="time">
                <div class="date">
                  {{ item.date }}
                </div>
                <div class="year">
                  {{ item.year }}
                </div>
              </div>
              <div class="text">
                <div class="tit">{{ item.title }}</div>
                <div class="tet" v-html="item.desc"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      pageData: {},
      bannerList: [],
      tabData: {},
      cpcenter: [],
      news: {},
      newsDataList: [],
      activeName: "",
      story: "",
      storys: "",
    };
  },
  methods: {
    getData() {
      axios({
        url: this.base_url.base_url + "/index.php/index/index/navigation_list",
        method: "get",
      })
        .then((res) => {
          this.bannerList = res.data.data.top_list[0].banner_list; // 轮播图
          this.pageData = res.data.data; // 网页数据
          this.cpcenter = res.data.data.bottom_list[1]; // 产品中心数据
          this.story = res.data.data.bottom_list[2]; // 品牌故事数据
          this.storys = res.data.data.bottom_list[2].child.slice(0, 12);
          this.news = res.data.data.bottom_list[3]; // 新闻中心数据
          this.activeName = res.data.data.bottom_list[3].child[0].id; // 新闻中心二级标题
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTabData() {
      // 公司简介详细数据
      axios({
        url:
          this.base_url.base_url +
          `/index.php/index/index/news_list?nid=6&cid=7`,
        method: "get",
      })
        .then((res) => {
          this.tabData = res.data.data.news_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleNav(item) {
      this.activeName = item.id;
      this.getNewsList(item.id);
    },
    clickBox() {
      // 点击品牌故事跳转
      this.$router.push("/page/index/goods");
    },
    clickCp(item) {
      // 点击产品中心跳转
      this.$router.push("/page/index/shop?id=" + item.id);
    },
    clickNew(item) {
      // 点击新闻中心跳转
      this.$router.push("/page/index/news?id=" + item.cid);
    },
    getNewsList(cid = 15) {
      // 获取新闻中心详细列表数据
      axios({
        url:
          this.base_url.base_url +
          "/index.php/index/index/news_list?nid=12&cid=" +
          cid,
        method: "get",
        params: {
          page: this.page,
          limit: 5,
        },
      })
        .then((res) => {
          this.newsDataList = res.data.data.news_data;
          this.newsDataList.forEach((v) => {
            // 转换切片时间格式
            if (v.the_date !== "") {
              v.year = v.the_date.split("-")[0];
              v.date =
                v.the_date.split("-")[1] + "-" + v.the_date.split("-")[2];
            } else {
              v.year = v.add_time.split(" ")[0].split("-")[0];
              v.date =
                v.add_time.split(" ")[0].split("-")[1] +
                "-" +
                v.add_time.split(" ")[0].split("-")[2];
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getData();
    this.getTabData();
    this.getNewsList();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1980px) {
  .c_box.left {
    left: 26% !important;
  }
}

.news {
  margin: 0 auto;
  width: 1200px;

  .pageList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 50px 0;

    .daohang {
      width: 375px;
      height: 42px;

      .fenbu {
        display: flex;

        div {
          width: 125px;
          height: 42px;
          text-align: center;
          line-height: 42px;
          cursor: pointer;
        }

        .active {
          background-color: #234ce2;
          color: #fff;
        }
      }
    }
  }

  .cont {
    width: 100%;
    display: flex;

    .left {
      margin-right: 30px;
    }

    .right {
      .news_list {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .new {
          border-top: 1px solid #ccc;
          display: flex;
          padding: 40px 0px 30px 30px;
          cursor: pointer;

          .time {
            color: #b8b8b8;
            margin-right: 20px;
            width: 100px;

            .date {
              font-size: 28px;
            }
          }

          .text {
            width: 500px;

            .tit {
              margin-bottom: 12px;
              font-weight: 600;
            }
          }
        }
      }

      :last-child {
        &.new {
          border-bottom: 1px solid #ccc;
        }
      }
    }
  }
}

.zhuye {
  width: 100%;

  .el-carousel {
    width: 100% !important;
    // height: 700px !important;
    // min-height: 1080px;

    .el-carousel__item {
      background-color: #fff !important;
    }
  }
}

.imgBoxs {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 60px;
  width: 1344px;

  .imgbox {
    width: 336px;
    height: 221px;
    position: relative;
    background-image: url("@/assets/img/bg/pingchang.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
    margin-bottom: 10px;

    .img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -49%);

      img {
        width: 314px;
        height: 196px;
      }
    }
  }

  .imgbox:hover {
    background-image: url("@/assets/img/bg/2.png");
  }

  .imgbox:active {
    background-image: url("@/assets/img/bg/3.png");
  }
}

.cpcenter {
  display: flex;
  margin: 50px auto 0;

  .item {
    position: relative;
    margin: 0 10px;
    width: 312px;
    padding: 30px 0;

    .logo {
      width: 87px;
      height: 87px;
      position: absolute;
      top: 159px;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .gang {
      position: absolute;
      bottom: 50%;
      left: 50%;
      transform: translate(-50%, 50%);
    }

    .text {
      position: absolute;
      bottom: 152px;
      left: 50%;
      transform: translate(-50%);
      color: #fff;
      text-align: center;

      .cn_name {
        font-size: 24px;
        margin-bottom: 20px;
      }

      .en_name {
        font-size: 20px;
      }
    }

    .look {
      display: none;
      color: #fff;
      text-align: center;
    }
  }

  :hover {
    background-color: #234ce2;

    .logo {
      top: 129px;
    }

    .gang {
      bottom: 33%;
    }

    .text {
      bottom: 40%;
    }

    .look {
      position: absolute;
      display: block;
      bottom: 20%;
      left: 50%;
      transform: translate(-50%);
    }

    // height: 640px;
    .bg {
      img {
        opacity: 0;
      }
    }
  }

  .bg {
    position: relative;
    width: 312px;
    height: 509px;
    cursor: pointer;

    .bgImg {
      width: 312px;
      height: 509px;
    }
  }
}

.c_introduction {
  width: 100%;
  height: 1123px !important;
  position: relative;
}

.c_box {
  width: 70%;
  margin: 0px auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.c_box .c_word {
  // width: 1350px;
  height: 100%;
  margin: 0 auto;
  /* background:red ; */
}

.c_box .c_pic {
  // width: 550px;
  height: 100%;

  /* background-color:skyblue; */
}

.c_tl {
  width: 133px;
  height: 32px;
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  position: relative;
  margin-left: 10px;
}

.e_tl {
  width: 141px;
  height: 12px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #949594;
  line-height: 30px;
  margin-left: 5px;
}

.c_text {
  width: 585px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #949594;
  line-height: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
}

.shuzi {
  display: flex;
  // justify-content: space-between;
}

.big_digit {
  width: 49px;
  height: 43px;
  font-size: 55px;
  font-family: AR DIN Sans Flat Bold;
  font-weight: 400;
  color: #234ce2;
}

.digit {
  display: flex;
  width: 160px;
  height: 85px;
  justify-content: center;
  border-right: 2px solid #dae6ef;
}

:last-child {
  border: 0;
}

.digit .top {
  display: flex;
  margin-left: 10px;
  justify-content: center;
}

.digit .bottom {
  width: 110px;
  height: 16px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
  text-align: center;
}

.digit .top .right {
  margin-left: 6px;
  // margin-top: 10px;
}

.digit .top .bottom1 {
  margin-top: 20px;
  width: 29px;
  height: 13px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.digit .top .top1 {
  width: 12px;
  height: 14px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #234ce2;
  margin-top: -3px;
}

.huise {
  width: 500px;
  height: 550px;
  background: #3e3a39;
  opacity: 0.1;
  position: absolute;
  right: 0;
  top: 30px;
}

.c_pic {
  position: relative;
  width: 100%;
  height: 100%;
  // overflow: hidden;
}

.c_pic img {
  width: 100%;
  height: 1173px;
  position: absolute;
}

.product_center {
  width: 100%;
  height: 700px;
  background-size: 100% 100%;
}

.brand {
  width: 100%;
  height: 700px;
  background-size: 100% 100%;
}

.new {
  width: 100%;
}

.new_pic {
  margin-top: 42px;
}

.new_pic img {
  width: 520px;
  height: 580px;
}

.tar {
  width: 75%;
  height: 42px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 90px;
}

.tar span {
  width: 72px;
  height: 17px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}

.tar_active {
  width: 125px;
  height: 42px;
  background: #234ce2;
  border-radius: 8px;
  text-align: center;
  line-height: 42px;
}

.tar_active span {
  color: #fff;
}

.specific_news {
  width: 100%;
  border-top: 1px solid #989898;
  margin-top: 90px;
}

.content {
  display: flex;
  justify-content: space-between;
  height: 24px;
  margin-top: 30px;
  margin-bottom: 40px;
}

.wenzi {
  width: 275px;
  height: 15px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-left: 15px;
  position: relative;
}

.wenzi::before {
  content: "";
  width: 9px;
  height: 9px;
  background: #000000;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  left: -15px;
}

.shijian {
  width: 70px;
  height: 24px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #989898;
}

.enter {
  width: 100%;
  position: relative;
  margin-bottom: 20px;
}

.enter img {
  position: absolute;
  right: 10px;
}
</style>
